export * from "/opt/render/project/src/local_modules/wallet/index.ts"